module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "el-radio",
    class: [
      _vm.border && _vm.radioSize ? 'el-radio--' + _vm.radioSize : '',
      {
        'is-disabled': _vm.isDisabled
      },
      {
        'is-focus': _vm.focus
      },
      {
        'is-bordered': _vm.border
      },
      {
        'is-checked': _vm.model === _vm.label
      }
    ],
    attrs: {
      "role": "radio",
      "aria-checked": _vm.model === _vm.label,
      "aria-disabled": _vm.isDisabled,
      "tabindex": _vm.tabIndex
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.model = _vm.isDisabled ? _vm.model : _vm.label
      }
    }
  }, [_c('span', {
    staticClass: "el-radio__input",
    class: {
      'is-disabled': _vm.isDisabled,
      'is-checked': _vm.model === _vm.label
    }
  }, [_c('span', {
    staticClass: "el-radio__inner"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    ref: "radio",
    staticClass: "el-radio__original",
    attrs: {
      "type": "radio",
      "aria-hidden": "true",
      "name": _vm.name,
      "disabled": _vm.isDisabled,
      "tabindex": "-1",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm.model, _vm.label)
    },
    on: {
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      },
      "change": [function($event) {
        _vm.model = _vm.label
      }, _vm.handleChange],
      "click": _vm.handleClick
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "el-radio__label",
    on: {
      "keydown": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0689d48e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/radio/src/radio.vue
// module id = 2065
// module chunks = 137